import { render } from "./ProgrammeDetails.pug?vue&type=template&id=b7e0e15c&lang=pug"
import script from "./ProgrammeDetails.js?vue&type=script&lang=js"
export * from "./ProgrammeDetails.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__